// src/pages/admin/mixedCompanyAssignJobs/StatPill.jsx — small rounded status/count badge
export default function StatPill({ children, tone = "gray" }) {
  const tones = {
    gray: "border-gray-200 bg-gray-50 text-gray-700",
    emerald: "border-emerald-200 bg-emerald-50 text-emerald-700",
    blue: "border-blue-200 bg-blue-50 text-blue-700",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${tones[tone] || tones.gray}`}
    >
      {children}
    </span>
  );
}
